// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8QZpk","disabled":"styles_disabled__18Ka5"};